module.exports = __webpack_public_path__ + "static/media/italic.0b781f25.svg";